import React, { useRef, useState } from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import LoadingSpinner from "../../Loading/component";
import varifiedIcon from "../../../assests/verifiedIcon.svg";
import './Productcategory.css';

const CategoryEditComponent = ({
  formData,
  imagePreview,
  loading,
  isFormValid,
  onChange,
  onImageChange,
  onSubmit,
  onBack,
  showSuccessPopup,
  successMessage,
  onCloseSuccessPopup
}) => {
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onImageChange(file);
    }
  };

  const handleRemoveImage = (e) => {
    e.stopPropagation();
    onImageChange(null);
  };

  return (
    <div className="category-edit-main-container">
      <Sidebar />
      
      {(loading) && (
        <div className="category-edit-full-page-loader">
          <LoadingSpinner />
        </div>
      )}
      
      {/* Success Popup */}
      {showSuccessPopup && (
        <div className="category-edit-success-overlay">
          <div className="category-edit-success-popup">
            <div className="category-edit-success-icon-wrapper">
             <div className="cat-attr-success-icon">
              <img src={varifiedIcon} alt="success" />
            </div>
            </div>
            <h3 className="category-edit-success-title">Update Successfully!</h3>
            <p className="category-edit-success-message">{successMessage}</p>
            <button 
              className="category-edit-success-button"
              onClick={onCloseSuccessPopup}
            >
              Done
            </button>
          </div>
        </div>
      )}
      
      <div className="category-edit-content-wrapper">
        <div className="category-edit-header-section">
          <button className="category-edit-back-button" onClick={onBack}>
            ←
          </button>
          <h1 className="category-edit-title">Edit Category</h1>
        </div>

        <div className="category-edit-form-wrapper">
          <div className="category-edit-form-card">
            <form onSubmit={onSubmit}>
              {/* Category Name Field */}
              <div className="category-edit-form-group">
                <label className="category-edit-form-label">
                  Category Name <span className="category-edit-required-star">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={onChange}
                  placeholder="Eg. Fresh Food, Electronics, Snacks"
                  className="category-edit-form-input"
                />
              </div>

              {/* Description Field */}
              <div className="category-edit-form-group">
                <label className="category-edit-form-label">Description (Optional)</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={onChange}
                  placeholder="Key details about this category"
                  className="category-edit-form-textarea"
                  rows="3"
                />
              </div>

              {/* Image Upload Field */}
              <div className="category-edit-form-group">
                <label className="category-edit-form-label">Image</label>
                <div 
                  className={`category-edit-image-upload-area ${dragActive ? 'category-edit-drag-active' : ''}`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragEnter={handleDrag}
                  onDragLeave={handleDrag}
                  onDragOver={handleDrag}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  {imagePreview ? (
                    <div className="category-edit-image-preview-container">
                      <img src={imagePreview} alt="Preview" className="category-edit-image-preview" />
                      <button 
                        type="button"
                        className="category-edit-remove-image-btn"
                        onClick={handleRemoveImage}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div className="category-edit-upload-placeholder">
                      <div className="category-edit-upload-icon">📤</div>
                      <p className="category-edit-upload-text">
                        <span className="category-edit-browse-link">Choose file</span> or drag here
                      </p>
                      <p className="category-edit-upload-hint">Png, Jpg, up to 5MB</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="category-edit-form-actions">
                <button 
                  type="submit" 
                  className={`category-edit-submit-btn ${isFormValid ? 'category-edit-btn-active' : 'category-edit-btn-disabled'}`}
                  disabled={!isFormValid || loading}
                >
                  {loading ? 'Updating...' : 'Update Category'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryEditComponent;